export default {
  N01b_SDKP_DVDT_ND112020: 'N01b_SDKP_DVDT_ND112020',
};
